import Vue from 'vue'
import App from './app'
import router from '@router'
import store from '@state/store'
import '@components/_globals'
import i18n from './locales/i18n'
import BootstrapVue from 'bootstrap-vue'
import VueQuillEditor from 'vue-quill-editor'
import StarRating from 'vue-star-rating'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import VueApexCharts from 'vue-apexcharts'
import JsonExcel from 'vue-json-excel'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import moment from 'moment'
import vuetify from '../src/plugins/vuetify'
import VueSuggestion from 'vue-suggestion'
Vue.use(VueSuggestion)
Vue.prototype.moment = moment
Vue.component('downloadExcel', JsonExcel)
Vue.component('apexchart', VueApexCharts)
Vue.component('star-rating', StarRating)
Vue.use(VueQuillEditor /* { default global options } */)
// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production'

// If running inside Cypress...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Ensure tests fail when Vue emits an error.
  Vue.config.errorHandler = window.Cypress.cy.onUncaughtException
}

Vue.use(BootstrapVue)
Vue.use(VueQuillEditor)

Vue.mixin({
  methods: {
    isAdmin: function() {
      if (
        JSON.parse(window.localStorage.getItem('auth.currentUser')).user
          .role === 'admin'
      ) {
        return true
      } else {
        return false
      }
    },
    isCollege: function() {
      if (
        JSON.parse(window.localStorage.getItem('auth.currentUser')).user
          .role === 'college'
      ) {
        return true
      } else {
        return false
      }
    },
    isHOD: function() {
      if (
        JSON.parse(window.localStorage.getItem('auth.currentUser')).user
          .role === 'hod'
      ) {
        return true
      } else {
        return false
      }
    },
    isTeacher: function() {
      if (
        JSON.parse(window.localStorage.getItem('auth.currentUser')).user
          .role === 'teacher'
      ) {
        return true
      } else {
        return false
      }
    },
    isAdministrator: function() {
      if (
        JSON.parse(window.localStorage.getItem('auth.currentUser')).user
          .role === 'administrator'
      ) {
        return true
      } else {
        return false
      }
    },
  },
})

const app = new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app')

// If running e2e tests...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Attach the app to the window, which can be useful
  // for manually setting state in Cypress commands
  // such as `cy.logIn()`.
  window.__app__ = app
}
